// src/redux/reducers.js
import * as actionTypes from './types';
import { SET_DATASET_LIST } from './types';

const initialState = {
  tagLinkList: [],
  // 组织
  organizationList: [],
  // 组织-树结构
  organizationTree: [],
  organizationTypeMap: {
    1: '行政线',
    2: '教学线',
  },
  // 职位
  positionList: [],
  // 角色
  roleList: [],
  // 年级
  gradeList: [],
  // 校区
  campusList: [],
  // 院系
  instituteList: [],
  // 系
  facultyList: [],
  // 专业
  majorList: [],
  // 班级
  clazzList: [],
  // 用户类型列表
  userTypeList: [],
  // 教学层次
  levelList: [],
  // 职位属性
  positionAttrList: [],
  // 数据集
  datasetList: [],
  // 模型类型
  modelTypeList: [
    { label: '对话模型', value: '对话模型' },
    { label: '推理模型', value: '推理模型' },
    // { label: '生成模型', value: '生成模型' },
    // { label: '多模态模型', value: '多模态模型' },
    { label: '检索增强模型', value: '检索增强模型' },
    // { label: '编码模型', value: '编码模型' },
  ],
  // 模型渠道
  modelChannelList: [],
  // 模型配置
  modelSetList: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_TAG_LINK_LIST:
      return { ...state, tagLinkList: action.payload };
    case actionTypes.SET_ORGANAZITION_LIST:
      return { ...state, organizationList: action.payload };
    case actionTypes.SET_ORGANAZITION_TREE:
      return { ...state, organizationTree: action.payload };
    case actionTypes.SET_POSITION_LIST:
      return { ...state, positionList: action.payload };
    case actionTypes.SET_ROLE_LIST:
      return { ...state, roleList: action.payload };
    case actionTypes.SET_GRADE_LIST:
      return { ...state, gradeList: action.payload };
    case actionTypes.SET_CAMPUS_LIST:
      return { ...state, campusList: action.payload };
    case actionTypes.SET_INSITITUTE_LIST:
      return { ...state, instituteList: action.payload };
    case actionTypes.SET_MAJOR_LIST:
      return { ...state, majorList: action.payload };
    case actionTypes.SET_CLAZZ_LIST:
      return { ...state, clazzList: action.payload };
    case actionTypes.SET_USER_TYPE_LIST:
      return { ...state, userTypeList: action.payload };
    case actionTypes.SET_LEVEL_LIST:
      return { ...state, levelList: action.payload };
    case actionTypes.SET_FACULTY_LIST:
      return { ...state, facultyList: action.payload };
    case actionTypes.SET_POSITION_ATTR_LIST:
      return { ...state, positionAttrList: action.payload };
    case actionTypes.SET_DATASET_LIST:
      return { ...state, datasetList: action.payload };
    case actionTypes.SET_MODEL_TYPE_LIST:
      return { ...state, modelTypeList: action.payload };
    case actionTypes.SET_MODEL_CHANNEL_LIST:
      return { ...state, modelChannelList: action.payload };
    case actionTypes.SET_MODEL_SET_LIST:
      return { ...state, modelSetList: action.payload };
    default:
      return state;
  }
};

export default reducer;
